import React, { useEffect } from 'react';
import styles from './InfoCard.module.css';

import NoAttach1 from '../../../assets/Imagess/NoAttach1.svg';
import NoAttach2 from '../../../assets/Imagess/NoAttach2.svg';
import moment from 'moment';

moment.locale('en');

const LTR_KEYS = new Set(['الوقت']); // add more keys if needed later

const renderValue = (val) => {
  if (Array.isArray(val)) {
    const sorted = [...val].sort((a, b) => new Date(a) - new Date(b));

    return (
      <div className={styles.dateList} dir='ltr'>
        {sorted.map((item, idx) => (
          <div key={idx} className={styles.dateRow} dir='ltr'>
            {moment(item).format('ddd, DD MMM YYYY • hh:mm A')}
          </div>
        ))}
      </div>
    );
  }

  return val ?? '-';
};

const Value = ({ k, children }) => {
  const isLtr = LTR_KEYS.has(k);
  return (
    <span
      dir={isLtr ? 'ltr' : undefined}
      className={isLtr ? styles.ltrValue : ''}
    >
      {children}
    </span>
  );
};

const UsersTable = ({ title, values, width = '', column = 1, text }) => {
  useEffect(() => {}, [values]);

  return (
    <div className={`${styles['card-container']} ${styles[width]}`}>
      <h3>{title}</h3>

      {text ? (
        <div className={`${styles['row']}`}>
          <div className={`${styles['w-100']}`}>
            <h6>{text}</h6>
          </div>
        </div>
      ) : null}

      {column === 1 && values ? (
        <div className={`${styles['row']}`}>
          <div className={`${styles['w-100']}`}>
            {Object.keys(values[0]).map((key, i) => (
              <h6 key={i}>
                {key.replace(/_/g, ' ')}{' '}
                <span>
                  : <Value k={key}>{renderValue(values[0][key])}</Value>
                </span>
              </h6>
            ))}
          </div>
        </div>
      ) : column === 2 && values ? (
        <div className={`${styles['row']}`}>
          <div className={`${styles['w-49']}`}>
            {Object.keys(values[0]).map((key, i) => (
              <h6 key={i}>
                {key.replace(/_/g, ' ')} :
                {values[0][key] === ': No Attachment' ? (
                  <>
                    <br />
                    <img
                      src={NoAttach1}
                      className={`${styles['imgLeft']}`}
                      alt=''
                    />
                  </>
                ) : (
                  ' '
                )}
                <span
                  className={
                    values[0][key] === ': No Attachment'
                      ? `${styles['redNote']}`
                      : ``
                  }
                >
                  <Value k={key}>{values[0][key]}</Value>
                </span>
                {values[0][key] === ': No Attachment' ? (
                  <img
                    src={NoAttach2}
                    className={`${styles['imgRight']}`}
                    alt=''
                  />
                ) : (
                  ' '
                )}
              </h6>
            ))}
          </div>

          <div className={`${styles['w-49']}`}>
            {Object.keys(values[1]).map((key, i) => (
              <h6 key={i}>
                {key.replace(/_/g, ' ')} :{' '}
                <Value k={key}>{renderValue(values[1][key])}</Value>
              </h6>
            ))}
          </div>
        </div>
      ) : column === 3 && values ? (
        <div className={`${styles['row']}`}>
          <div className={`${styles['w-30']}`}>
            {Object.keys(values[0]).map((key, i) => (
              <h6 key={i}>
                {key.replace(/_/g, ' ')}{' '}
                <span>
                  : <Value k={key}>{renderValue(values[0][key])}</Value>
                </span>
              </h6>
            ))}
          </div>

          <div className={`${styles['w-30']}`}>
            {Object.keys(values[1]).map((key, i) => (
              <h6 key={i}>
                {key.replace(/_/g, ' ')} :{' '}
                <Value k={key}>{renderValue(values[1][key])}</Value>
              </h6>
            ))}
          </div>

          <div className={`${styles['w-30']}`}>
            {Object.keys(values[2]).map((key, i) => (
              <h6 key={i}>
                {key.replace(/_/g, ' ')}{' '}
                <span>
                  {' '}
                  : <Value k={key}>{values[2][key]}</Value>
                </span>
              </h6>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default UsersTable;
